import React, { useEffect, useState } from "react";
import { Avatar, Flex, message, Space } from "antd";
import {
  Card,
  Wrapper,
  TextWrapper,
  Text,
  ProductItem,
  TextSm,
  TextSmPrimary,
  TextSmGray,
} from "./DashboardStyled";
import { IconEmptyTable, IconRight } from "../../assets/icons";
import api from "../../api/api";
import { useNavigate } from "react-router-dom";
import { PRIVATE_ROUTE } from "../../route.constants";
import { useTranslation } from "react-i18next";

const TopProducts = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const {t} = useTranslation();

  const getTopProducts = () => {
    api
      .getTopProducts()
      .then((res) => setData(res.data))
      .catch((err) => message.error(err));
  };

  useEffect(() => {
    getTopProducts();
  }, []);

  const adminData = localStorage.getItem("admin");
  const admin = adminData ? JSON.parse(adminData) : null;
  const role = admin?.role;

  const goToDetails = (item) => {
    if (role === "MERCHANT_ADMIN") {
      navigate(
        `/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.PRODUCT_DETAILS}/${item.product_id}`
      );
    } else {
      message.warning("Access Denied!");
    }
  };

  const goToBestSellingProducts = () => {
    if (role === "MERCHANT_ADMIN") {
      navigate(`/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.BEST_SELLING_PRODUCTS}`);
    } else {
      message.warning("Access Denied!");
    }
  };
  // if (data.length > 0)
  return (
    <Card style={{ height: "100%" }}>
      <Wrapper>
        <TextWrapper onClick={goToBestSellingProducts}>
          <Text>{t("top_selling_product",  {count: data.length > 0 && data?.length} )}</Text>
          <IconRight />
        </TextWrapper>
        {data.map((item, index) => (
          <ProductItem key={index} onClick={() => goToDetails(item)}>
            <TextSm>{index + 1}</TextSm>
            <Avatar shape="square" style={{minWidth: 50}} size={52} src={item?.image} />
            <div style={{ overflow: "hidden", maxWidth: "100%" }}>
              <TextSm
                style={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  width: "100%",
                  fontSize: 13
                }}
              >
                {item?.product_name?.primary}
              </TextSm>
              <Space size={"small"}>
                <TextSmPrimary>{item?.total_orders}</TextSmPrimary>
                <TextSmGray>{t('orders')}</TextSmGray>
              </Space>
            </div>
          </ProductItem>
        ))}
        {data.length === 0 && (
          <Flex
            style={{ flexDirection: "column", marginTop: "100px" }}
            align="center"
            justify="center"
            gap={4}
          >
            <IconEmptyTable />
            <Text>{t('no_product_found')}</Text>
          </Flex>
        )}
      </Wrapper>
    </Card>
  );
};

export default TopProducts;
